import React from 'react';
import { RefreshCw, Sparkles, TrendingDown, TrendingUp, Activity } from 'lucide-react';
import { Button } from '../ui/Button';
import { Skeleton } from '../ui/Skeleton';
import { forecasts } from '../../data/analytics';
import { useAiRun } from '../../hooks/useAiRun';
const RUN_STAGES = ['Loading 41 closed and 15 live records', 'Fitting stage-transition model', 'Projecting gate outcomes', 'Writing forecast narratives'];
const toneIcon = {
  positive: TrendingUp,
  watch: Activity,
  risk: TrendingDown
};
const toneClasses = {
  positive: 'text-[#7fe0b6]',
  watch: 'text-[#f0c94f]',
  risk: 'text-[#ff9d9b]'
};
export function ForecastPanel() {
  const run = useAiRun({
    stages: RUN_STAGES,
    stageDuration: 700
  });
  const running = run.state === 'running';
  return <section className="rounded-sm border-l-4 border-uae-gold bg-uae-navy p-4 text-white" data-id="element-396" data-mp="39m6vs9qzz22f">
      <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-397" data-mp="34n3yxcl6825j">
        <div data-id="element-398" data-mp="34mu9bq41fx0d">
          <h2 className="flex items-center gap-1.5 text-[13px] font-semibold" data-id="element-399" data-mp="34pgczent5sdb">
            <Sparkles className="h-4 w-4" aria-hidden="true" data-id="element-400" data-mp="r1dp12sgweem" />
            AI forecast
          </h2>
          <p className="mt-1 text-[11px] text-white/55" data-id="element-401" data-mp="v1fhqmg85xhr">
            Stage-transition model v4.2 · trained on 41 closed records and 15 live records
          </p>
        </div>
        <Button variant="ghost" size="xs" onClick={run.start} disabled={running} className="text-white/75 hover:bg-white/10 hover:text-white" data-id="element-402" data-mp="1503m4ifaee2z">
          <RefreshCw className={`mr-1 h-3 w-3 ${running ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-403" data-mp="cdix3omaae2l" />
          {running ? 'Recomputing' : 'Recompute'}
        </Button>
      </div>

      {running ? <div className="mt-4 space-y-3" aria-live="polite" data-id="element-404" data-mp="m4dikqrph9mz">
          {[0, 1, 2, 3].map(index => <div key={index} className="rounded-sm bg-white/5 p-3" data-id="element-405" data-mp="3kqq2xuyfgtx7">
              <Skeleton className="h-3 w-2/3 bg-white/10" data-id="element-406" data-mp="3pq2rql8v0b2f" />
              <Skeleton className="mt-2 h-3 w-full bg-white/10" data-id="element-407" data-mp="3hqfvcaqkh5i8" />
            </div>)}
          <p className="text-[11px] text-white/60" data-id="element-408" data-mp="3dpw1bg1aii0b">{run.currentStage}…</p>
        </div> : <ul className="mt-4 grid gap-2.5 lg:grid-cols-2" data-id="element-409" data-mp="3rhalhq6xop8y">
          {forecasts.map(forecast => {
        const Icon = toneIcon[forecast.tone];
        return <li key={forecast.id} className="rounded-sm bg-white/5 p-3" data-id="element-410" data-mp="3mk0q7twv5jd7">
                <div className="flex items-start justify-between gap-3" data-id="element-411" data-mp="2ysde4i49gcuz">
                  <p className="flex items-start gap-1.5 text-[12px] font-medium leading-snug text-white" data-id="element-412" data-mp="2urtixk38zjbh">
                    <Icon className={`mt-0.5 h-3.5 w-3.5 shrink-0 ${toneClasses[forecast.tone]}`} aria-hidden="true" data-id="element-413" data-mp="38r2q5u9h733b" />
                    {forecast.label}
                  </p>
                  <span className="shrink-0 font-mono text-[10px] text-white/50" data-id="element-414" data-mp="j0xxypohq9sn">
                    {forecast.confidence}%
                  </span>
                </div>
                <p className="mt-1.5 pl-5 text-[11px] leading-relaxed text-white/60" data-id="element-415" data-mp="20x9d41ruu9mo">
                  {forecast.detail}
                </p>
                <p className="mt-1.5 pl-5 text-[10px] uppercase tracking-[0.1em] text-white/40" data-id="element-416" data-mp="1ry5v714fc09r">
                  {forecast.horizon}
                </p>
              </li>;
      })}
        </ul>}
    </section>;
}